/* eslint-disable react/function-component-definition */
import React, { useState } from "react";
import dayjs from "dayjs";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { SxProps, TextField } from "@mui/material";

export type DatePickerType = {
  label: string;
  date: Date;
  setDate: (date: Date) => void;
  maxDate?: Date;
  minDate?: Date;
  sx?: SxProps;
};

const DatePicker = ({
  label,
  date,
  setDate,
  maxDate,
  minDate,
  sx,
}: DatePickerType) => {
  const [value, setValue] = useState<Date>(date);

  const onChange = (event: Date | null) => {
    if (event !== null) {
      setValue(event);
      setDate(event);
    }
    // console.log('onChangePicker: ', event, event?.getUTCDate(), Intl.DateTimeFormat().resolvedOptions().timeZone)
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        mask="____/__/__"
        label={label}
        value={value}
        maxDate={maxDate}
        minDate={minDate}
        onChange={onChange}
        inputFormat="yyyy/MM/dd"
        renderInput={(params) => {
          return (
            <TextField
              size="small"
              {...params}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
